/**
 * 主布局：顶部 Header、左侧菜单、内容区。
 * 内容区按当前页面的权限要求决定渲染页面还是无权限提示。
 */
import { useState } from 'react'
import { Layout } from 'antd'
import { Outlet, useMatches } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth'
import { canAccess } from '@/router/guards'
import { ForbiddenResult } from '@/features/common/ForbiddenResult'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import styles from './AdminLayout.module.css'

export function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const matches = useMatches()
  // 订阅 user，权限变化时重新判断
  useAuthStore((state) => state.user)
  const checker = useAuthStore.getState()
  const allowed = matches.every((match) => canAccess(match.staticData, checker))

  return (
    <Layout className={styles.layout}>
      <Layout.Header className={styles.header}>
        <Header collapsed={collapsed} onToggleCollapsed={() => setCollapsed(!collapsed)} />
      </Layout.Header>
      <Layout>
        <Layout.Sider className={styles.sider} width={256} collapsedWidth={80} collapsed={collapsed} trigger={null}>
          <Sidebar collapsed={collapsed} />
        </Layout.Sider>
        <Layout.Content className={styles.content}>{allowed ? <Outlet /> : <ForbiddenResult />}</Layout.Content>
      </Layout>
    </Layout>
  )
}

